module.exports = __webpack_public_path__ + "static/media/alleyesongeorgia.9e94f256.png";